import React from "react";
import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "baseline",
    gap: theme.spacing(0.5, 2),
    rowGap: theme.spacing(1),
    padding: theme.spacing(1.5, 2),
    borderRadius: 10,
    backgroundColor:
      theme.palette.type === "dark"
        ? "rgba(255,255,255,0.04)"
        : "rgba(0,0,0,0.03)",
    border: `1px solid ${theme.palette.divider}`
  },
  item: {
    display: "inline-flex",
    alignItems: "baseline",
    flexWrap: "wrap",
    maxWidth: "100%"
  },
  label: {
    fontSize: "0.7rem",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    color: theme.palette.text.secondary,
    marginRight: 6,
    whiteSpace: "nowrap"
  },
  value: {
    fontSize: "0.875rem",
    fontWeight: 500,
    color: theme.palette.text.primary,
    wordBreak: "break-word"
  },
  sep: {
    color: theme.palette.text.disabled,
    margin: theme.spacing(0, 0.5),
    userSelect: "none"
  }
}));

/**
 * Horizontal, wrap-friendly field list (label + value inline, separated by ·).
 */
const ErpCompactInfo = ({ fields, className }) => {
  const classes = useStyles();
  const visible = (fields || []).filter(
    (f) => f.value != null && String(f.value).trim() !== ""
  );

  if (visible.length === 0) return null;

  return (
    <Box className={`${classes.root} ${className || ""}`}>
      {visible.map((f, i) => (
        <React.Fragment key={f.label}>
          {i > 0 && (
            <Typography component="span" className={classes.sep}>
              ·
            </Typography>
          )}
          <span className={classes.item}>
            <Typography component="span" className={classes.label}>
              {f.label}
            </Typography>
            <Typography component="span" className={classes.value}>
              {f.value}
            </Typography>
          </span>
        </React.Fragment>
      ))}
    </Box>
  );
};

export default ErpCompactInfo;
